<template>
  <div class="clearcache">
    {{ status }}
  </div>
</template>

<script>
import clearcache from 'api/clearcache'

export default {
  name: 'clearcache',
  data () {
    return {
      status: 'Please wait for clearing cache ...'
    }
  },
  created () {
    clearcache.postClearCache()
        .then((response) => {
          this.status = 'All cache is cleared !!!'
          console.log(response.data)
        })
        .catch((error) => {
          this.status = error
          console.log('Cleared Cache Error !!!', error)
        })
  }
}
</script>

<style lang="scss">
  .clearcache {
    text-align: center;
    font-size: 40px;
    color: #bbb;
    padding: 20% 20px;
    height: 100vh;
    vertical-align: middle;
  }
</style>


// WEBPACK FOOTER //
// component.vue?3d8def87